import Swiper from 'swiper/bundle';
import 'swiper/css';

export default class Quotes {
  constructor() {  
    this.swiper = new Swiper('section.quotes .swiper', {
      speed: 1000,
      loop: true,
      autoplay: {
        delay: 2000,
        disableOnInteraction: true
      },
    });
  }
}

addEventListener('DOMContentLoaded', (event) => {
  new Quotes();
});
